import {
  CommonNetworkService,
  Helpers,
} from "@tpd-web-common-libs/nodejs-library";

class USER_CONTEXT_URL_CONSTANTS {
  static BASE_URL = "api/priv/contesto-utente/v1/me/account";
}
export interface IUserContext {
  ultimaLogin: string;
  statoAccount: string;
  indirizzoResidenza: string;
  statoDocumento: string;
  privacy: string;
  livelloDiServizio: string;
  tipo: string;
  compagniaPresente: string;
  cambiaRecapitiAbilitato: string;
  nome: string;
  cognome: string;
  email: string;
  cellulare: string;
  cf: string;
}

class ContestoUtenteService {
  private commonNetworkService: CommonNetworkService;

  constructor() {
    this.commonNetworkService = new CommonNetworkService();
  }

  public recuperaContestoUtente(): Promise<IUserContext | void> {
    const completeUrl = `${Helpers.EndpointHelper.getHostEndpoint()}${
      USER_CONTEXT_URL_CONSTANTS.BASE_URL
    }`;
    return this.commonNetworkService.get<IUserContext | void>(completeUrl);
  }
}

export default new ContestoUtenteService();
